/**
 * 別SPAに遷移する際に指定するCONNECTION_KIND
 * key:クエリパラメータに指定するためのキー
 * value：実際に指定するCONNECTION_KINDの値
 */
export const CONNECTION_KIND_OTHER_SPA_TRANSITION = {
  key: 'CONNECTION_KIND',
  value: 'ZZZ',
};
